module.exports = __webpack_public_path__ + "img/banner9.2dee5ace.png";